module.exports = __webpack_public_path__ + "img/honer_video_cover.d335f6ce.png";